<template>
  <b-row>
    <b-col>
      <b-card>
        <div class="mb-1">
          <i class="ml-2 fa fa-file-invoice fa-lg"></i><span class="h6 ml-2">{{ $t('views.documents.index') }}</span>
          <hr class="mt-1 mb-0">
        </div>
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div v-else-if="!isLoading && items.length < 1">
          {{ $t('views.documents.list.noDocuments') }}
        </div>
        <table v-else class="table table-sm table-hover table-striped">
          <thead>
          <tr>
            <th></th>
            <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
            <th>{{$t('views.exsbinvoices.list.number')}}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>
              <i v-if="getInvoiceStatusId(item) === 1" style="color: #dc3545" class="fa fa-circle fa-lg" v-b-tooltip:hover :title="item.invoiceStatus.name"></i>
              <i v-else style="color: #28a745" class="fa fa-circle fa-lg" v-b-tooltip:hover :title="item.invoiceStatus.name"></i>
            </td>
            <td>
              {{ $moment(item.paymentDeadline).format('YYYY-MM-DD') }}
            </td>
            <td>
              <router-link v-if="ableToViewInvoices" :to="{ name: 'EXSBInvoiceShow', params: { id: item['@id'] } }">
                {{ item.number }}
              </router-link>
              <div v-else>{{ item.number }}</div>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-xs btn-link fa fa-file-pdf fa-lg"
                @click="toggleInvoiceShowModal(item)"
              ></button>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="view">
          <pagination
            :view="view"
            @getPage="getPage($event)"
          ></pagination>
        </div>
      </b-card>
    </b-col>
    <InvoiceShowModal></InvoiceShowModal>
  </b-row>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ApiService from '@/utils/ApiService'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import getId from '@/utils/getIdFromLink'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import InvoiceShowModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceShowModal'

export default {
  name: 'ClientDocuments',
  components: {
    Loader,
    Pagination,
    InvoiceShowModal
  },
  data () {
    return {
      firms: []
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'exsbinvoice/list/isLoading',
      items: 'exsbinvoice/list/items',
      view: 'exsbinvoice/list/view'
    }),
    ableToViewInvoices () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    }
  },
  watch: {
    'firms' (val) {
      if (val) {
        this.getPage('e_x_s_b_invoices', {
          firm: val[0] ? val[0]['@id'] : ''
        })
      }
    }
  },
  created () {
    this.fetchFirm()
  },
  methods: {
    toggleInvoiceShowModal (item) {
      this.fetchInvoiceAsPDF(getId(item['@id']))
      this.setInvoiceNumber(item.number)
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/showModal/toggleModal',
      setInvoiceNumber: 'exsbinvoice/showModal/setInvoiceNumber'
    }),
    ...mapActions({
      getPage: 'exsbinvoice/list/getItems',
      fetchInvoiceAsPDF: 'exsbinvoice/showModal/fetchInvoiceAsPDF'
    }),
    getInvoiceStatusId (invoice) {
      return parseInt(getId(invoice.invoiceStatus['@id']))
    },
    async fetchFirm () {
      let params = {
        employee: getUserRoles().id_userdata,
        pagination: false
      }
      const response = await new ApiService('user_data_employees', params).getResults()
      this.firms = response.items
    }
  }
}
</script>

<style scoped>
.btn-xs {
  border-radius: 5px;
  padding: 5px 5px;
}
</style>
